import { useEffect, useState } from "react";
import { Form, Input, Spin } from "antd";
import { toast } from "react-toastify";
import { axiosInstanceB2B, Toaster } from "@share/utils";
import { BlueButton } from "@share/components";
import { FormattedMessage, IntlShape, useIntl } from "react-intl";
import PhoneInput from 'react-phone-number-input'

//import img from '@assets/images/avatar/avatar01.png';
import img from '@assets/images/avatar/marker.svg';

import './style.scss';
import 'react-phone-number-input/style.css'
import { Urls } from "@share/constants";
import { FileType } from "@constants";
import { useDispatch } from "react-redux";
import { setLoginUserAdditionalData } from "@share/store/slices";

export const personalDetailsForm = (intl : IntlShape) => [
  // {
  //   name: "username",
  //   label: "Username",
  //   placeholder: "First name",
  //   isDisabled: true,
  //   rules: [{ required: true, message: "Username is required" }],
  // },
  {
    name: "firstName",
    label: intl.formatMessage({ id: 'first.name' }),
    placeholder: intl.formatMessage({ id: 'first.name' }),
    isDisabled: false,
    rules: [{ required: true, message: intl.formatMessage({ id: 'first.name.required' }) }],
  },
  {
    name: "lastName",
    label: intl.formatMessage({ id: 'last.name' }),
    placeholder: intl.formatMessage({ id: 'last.name' }),
    isDisabled: false,
    rules: [{ required: true, message: intl.formatMessage({ id: 'last.name.required' }) }],
  },
  {
    name: "email",
    label: intl.formatMessage({ id: 'email' }),
    placeholder: intl.formatMessage({ id: 'company.email' }),
    isDisabled: false,
    rules: [
      {
        required: true,
        type: "email" as const,
        message: intl.formatMessage({ id: 'email.required' }),
      },
    ],
  },
  {
    name: "phone",
    label: intl.formatMessage({ id: 'phone' }),
    placeholder: "Enter phone number",
    isDisabled: false,
    rules: [{ required: false }],
  },
];

interface IProps {
  data?: any;
}

function PersonalInfoComponent(props: IProps) {
  const { data } = props;
  const [form] = Form.useForm<IProps>();
  const dispatch = useDispatch();
  const [file, setFile] = useState();
  const [profilePic, setProfilePic] = useState<string>(img);
  const [loading, setLoading] = useState<boolean>(false);
  const [imageValid, setImageValid] = useState(false);

  useEffect(() => {
    handleImage();
  }, [data?.userAdditionalData?.profilePhoto]);

  const handleImage = async () => {
    var image = new Image();
    image.onload = () => setImageValid(true)
    image.onerror = () => setImageValid(false)
    image.src = data?.userAdditionalData?.profilePhoto || '';
  };
  
  const handleUpload = (info: any) => {
    const file = info.target.files[0] as File;
    if (file.size > 20 * 1024 * 1024) { // 20MB
      Toaster.warning(intl.formatMessage({ id: 'file.too.large' }));
      return;
    }
    setFile(info.target.files[0]);
    const reader = new FileReader();
    reader.onload = (e) => {
      setProfilePic(e?.target?.result as string);
    };
    reader.readAsDataURL(file);
  };

  const onFinish = async (values: any) => {
    let cloneData: any = {
      userId: data.userId,
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone,
    };
  
    const hasFile = !!file;
    const hasDataChanges = (
      values.email !== data.email ||
      values.firstName !== data.firstName ||
      values.lastName !== data.lastName ||
      values.phone !== data.userAdditionalData?.phone
    );
  
    setLoading(true);
  
    try {
      const apiCalls: Promise<any>[] = [];
  
      if (hasFile) {
        const formData = new FormData();
        formData.append(`${FileType}`, file);
  
        const uploadPromise = axiosInstanceB2B.post(Urls.UploadUserProfilePicture, formData);
  
        const fetchAndDispatch = uploadPromise.then(() =>
          axiosInstanceB2B.get(`/identity/users/${data?.userId}`).then((response) => {
            const userData = response.data?.userAdditionalData;
            dispatch(setLoginUserAdditionalData(userData));
          })
        );
  
        apiCalls.push(fetchAndDispatch);
      }
      if (hasDataChanges) {
        apiCalls.push(axiosInstanceB2B.post(Urls.SaveProfileInfo, cloneData));
      }
  
      if (apiCalls.length > 0) {
        await Promise.all(apiCalls);
        toast.success(intl.formatMessage({ id: 'success.details.updated' }), { theme: 'colored' });
      } else {
        toast.info(intl.formatMessage({ id: 'no.changes' }), { theme: 'colored' });
      }
  
    } catch (error) {
      console.error('Error saving data:', error);
      toast.error(intl.formatMessage({ id: 'error.details.updated' }), { theme: 'colored' });
    } finally {
      setLoading(false);
    }
  };
  
 
  useEffect(() => {
    setProfilePic(data?.userAdditionalData?.profilePhoto);
    form.setFieldsValue(data);
    form.setFieldValue('phone', data?.userAdditionalData?.phone)
  }, [data, form]);

  const intl = useIntl();
  const personalDetailsFormInfo = personalDetailsForm(intl);
  return (
    <div className="card shadow-sm border mb-5 personal-info">
      <div className="card-header border-bottom">
        <h4 className="card-header-title">
          <i className="bi bi-person mx-2"></i><FormattedMessage id="Personal.Information" />
        </h4>
      </div>
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          initialValues={data}
          onFinish={onFinish}
          className="card-body"
        >
          <div className="col-12">
            <label className="form-label">
              <FormattedMessage id="upload.profile.photo" />
              <span className="text-danger">*</span>
            </label>
            <div className="d-flex align-items-center">
              <label
                className="position-relative me-4"
                htmlFor="uploadfile-1"
                title="Replace this pic"
              >
                <span className="avatar avatar-xl">
                  <img
                    id="uploadfile-1-preview"
                    className="avatar-img rounded-circle border border-white border-3 shadow"
                    src={imageValid ? profilePic : img}
                    alt="profilePic"
                  />
                </span>
              </label>
              <label
                className="btn btn-sm btn-outline-primary mb-0"
                htmlFor="uploadfile-1"
              >
                <FormattedMessage id="upload.new" />
              </label>
              <input
                id="uploadfile-1"
                className="form-control d-none"
                type="file"
                onChange={handleUpload}
              />
            </div>
          </div>
          <div className="form-items-container">
            <div className="_form-grid">
              {personalDetailsFormInfo?.map((item) => (
                <Form.Item
                  key={item.name}
                  name={item.name}
                  label={item.label}
                  rules={item.rules}
                >
                  {item.name !== 'phone'
                    ? <Input
                      placeholder={item.placeholder}
                      type={"text"}
                      disabled={item?.isDisabled}
                      className='form-control form-control-lg'
                    />
                    : <PhoneInput
                      placeholder={item.placeholder}
                      defaultCountry="US"
                      disabled={item?.isDisabled}
                      onChange={() => { }}
                    />
                  }
                </Form.Item>
              ))}
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <BlueButton
              block
              size="large"
              type="primary"
              htmlType="submit"
              className="btn btn-primary commonBlueBtn"
              disabled={loading}
            >
              <FormattedMessage id="save.changes" />
            </BlueButton>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

const PersonalInfo = PersonalInfoComponent;
export default PersonalInfo;